import React from 'react';
import classnames from 'classnames';
import { Icon, IconProps } from '../icon';

import styles from './icon-button.module.scss';
import { Size } from '../types';

export type IconButtonProps = {
  label?: string;
  iconName: IconProps['name'];
  ariaLabel: string;
  variant: 'primary' | 'secondary' | 'ghost' | 'secondary-on-media';
  size?: Size;
} & Pick<
  React.ButtonHTMLAttributes<HTMLButtonElement>,
  | 'id'
  | 'type'
  | 'disabled'
  | 'onClick'
  | 'className'
  | 'aria-labelledby'
  | 'aria-expanded'
  | 'aria-controls'
  | 'autoFocus'
  | 'onContextMenu'
>;

const baseClass = 'icon-button';

export const IconButton: React.FC<IconButtonProps> = ({
  label,
  'aria-labelledby': ariaLabelledBy,
  iconName,
  ariaLabel,
  disabled,
  variant = 'primary',
  size = '300',
  className,
  onClick,
  type,
  autoFocus,
  onContextMenu
}) => {
  const classes = classnames(
    styles[baseClass],
    styles[`${baseClass}--${variant}`],
    styles[`${baseClass}--${size}`],
    className
  );

  const Button = () => (
    <button
      data-testid="icon-button-component"
      className={classes}
      aria-label={ariaLabel}
      disabled={disabled}
      type={type}
      onClick={onClick}
      aria-labelledby={ariaLabelledBy}
      autoFocus={autoFocus}
      onContextMenu={onContextMenu}
    >
      <Icon name={iconName} className={styles[`${baseClass}__icon`]} />
    </button>
  );

  if (label) {
    return (
      <div className={styles[`${baseClass}-container`]}>
        <Button />
        <span className={styles[`${baseClass}__label`]} id={ariaLabelledBy}>
          {label}
        </span>
      </div>
    );
  } else {
    return <Button />;
  }
};
